import React, { useState } from 'react';
import { CheckCircle, Upload } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { updateAboutUsContent, uploadImage } from '../../utils/api';
import RichTextEditor from '../RichTextEditor';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const AdminAboutUs = ({ aboutUsContent: initial, loadData }) => {
  const [content, setContent] = useState(initial);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  React.useEffect(() => { setContent(initial); }, [initial]);

  return (
    <div className="space-y-6" data-testid="about-us-cms-tab">
      <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
        <h2 className="text-xl font-bold text-slate-900 mb-4">About Us Content</h2>
        <div className="space-y-6">
          <div><Label>Who We Are</Label><RichTextEditor value={content.who_we_are} onChange={(val) => setContent({...content, who_we_are: val})} placeholder="Describe who you are..." /></div>
          <div><Label>Our Focus</Label><RichTextEditor value={content.our_focus} onChange={(val) => setContent({...content, our_focus: val})} placeholder="Describe your focus..." /></div>
          <div><Label>Our Logo Description</Label><RichTextEditor value={content.our_logo_description} onChange={(val) => setContent({...content, our_logo_description: val})} placeholder="Describe your logo..." /></div>
          <div><Label>Our Logo Image URL</Label>
            <div className="flex gap-2">
              <Input value={content.our_logo_url} onChange={(e) => setContent({...content, our_logo_url: e.target.value})} placeholder="Enter logo URL or upload" />
              <label className="cursor-pointer"><input type="file" accept="image/*" className="hidden" onChange={async (e) => {
                const file = e.target.files[0]; if (!file) return;
                setUploadingLogo(true);
                try { const formData = new FormData(); formData.append('file', file); const res = await uploadImage(formData); setContent({...content, our_logo_url: `${BACKEND_URL}${res.data.file_url}`}); toast.success('Logo uploaded'); }
                catch (err) { toast.error('Failed'); } finally { setUploadingLogo(false); }
              }} /><Button type="button" variant="outline" disabled={uploadingLogo}>{uploadingLogo ? 'Uploading...' : <Upload className="h-4 w-4" />}</Button></label>
            </div>
            {content.our_logo_url && <img src={content.our_logo_url} alt="Logo preview" className="mt-2 h-20 object-contain" />}
          </div>
          <Button className="bg-[#8B1818] text-white" onClick={async () => {
            try { await updateAboutUsContent(content); toast.success('About Us saved'); loadData(); } catch (err) { toast.error('Failed'); }
          }}><CheckCircle className="mr-2 h-4 w-4" />Save About Us Content</Button>
        </div>
      </div>
    </div>
  );
};
